import { Component } from '@angular/core'
import { Routes } from '@angular/router'

import { authGuard } from './guards/auth.guard'
import { DashboardComponent } from './layout'
import { ContactDetailComponent } from './pages/contacts/contact-detail/contact-detail.component'
import { ContactsComponent } from './pages/contacts/contacts.component'
import { LoginComponent } from './pages/login/login.component'
import { OverviewComponent } from './pages/overview/overview.component'
import { TasksComponent } from './pages/tasks/tasks.component'

@Component({
  selector: 'app-health',
  template: '<p>Systems Operational</p>',
})
class HealthCheckComponent {}

export const routes: Routes = [
  {
    path: 'login',
    component: LoginComponent,
  },
  {
    path: 'health',
    component: HealthCheckComponent,
  },
  {
    path: '',
    // pathMatch: 'full',
    canActivate: [authGuard],
    component: DashboardComponent,
    children: [
      { path: '', pathMatch: 'full', redirectTo: 'tasks' },
      { path: 'overview', component: OverviewComponent },
      { path: 'tasks', component: TasksComponent },
      { path: 'tasks/:taskId', component: TasksComponent },
      {
        path: 'contacts',
        component: ContactsComponent,
      },
      { path: 'contacts/:contactId', component: ContactDetailComponent },
    ],
  },
]
